<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import TreeMenu from "../../../components/treeMenu";
import appConfig from "../../../../app.config";
import Table from "../../../components/table";
import Empty from "@/components/empty";
import moment from "moment";
import "moment-timezone";
import _ from "loadsh";
import SwiperTool from "@/components/swiperTool.vue";
import Swal from "sweetalert2";
import axios from "axios";

import MessageAlert from "@/components/common/MessageAlert";
import { ElPopover } from "element-plus";
import "element-plus/theme-chalk/el-date-picker.css";
import "element-plus/es/components/date-picker/style/css";
import { API_SVC_HOST, SOCKET_SVC_HOST, SF_API_PREFIX } from "@/config/common";
import { urlFormat ,numberFormat } from "@/helpers/common";
import i18n from "@/i18n";

import {
  getInstancesDetail,
  deleteInstancesDetailId,
  getInstancesDetailId,
  getLatestTimeseries,
  editInstance,
  createInstance,
  getInstanceDetailTree,
} from "@/service/index";
import vueQr from "vue-qr/src/packages/vue-qr.vue";
export default {
  page: {
    title: i18n.global.t("page.work-order.device.text"),
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  data() {
    return {
      copyNumber: null,
      currentType: 2,
      title: this.$t("page.work-order.device.text"),
      selected: "1-1",
      items: [
        {
          text: this.$t("menu.equipment-management.model-management.text"),
        },
        {
          text: this.$t("page.work-order.device.text"),
          active: true,
        },
      ],
      assetList: [],
      originAssetList: [], //保存一份原始数据，树结构搜索过滤使用
      tableData: [
        {
          name: this.$t("page.work-order.rated_voltage"),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t("page.work-order.rated_voltage"),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t("page.work-order.rated_voltage"),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
        {
          name: this.$t("page.work-order.rated_voltage"),
          id: "yjrtyryrtkldkfo-jin9-409",
          newData: 677,
          unit: "v",
          update: "2022年3月23日 10:00:--（UTC+8:00）",
        },
      ],
      column: [
        { dataIndex: "name", title: this.$t("page.work-order.device.name") },
        // { dataIndex: "id", title: "ID", width: "40%" },
        { dataIndex: "newData", title: this.$t("page.work-order.device.latest_value")},
        { dataIndex: "unit", title: this.$t("page.work-order.device.unit") },
        { dataIndex: "update", title: this.$t("page.work-order.device.latest_time") },
      ],
      emptyInfo: {
        title: this.$t("page.work-order.device.no_device_create"),
        description: this.$t("page.work-order.device.device_create"),
        icon: "bx bxs-error-circle",
      },
      detailInfo: {},
      //属性
      attributes: [],
      attributesColumn: [
        { dataIndex: "name", title: this.$t("page.work-order.device.name") },
        // { dataIndex: "id", title: "ID", width: "30%" },
        { dataIndex: "value", title: this.$t("page.work-order.device.latest_value")},
        { dataIndex: "unit", title: this.$t("page.work-order.device.unit") },
        { dataIndex: "updateTime", title: this.$t("page.work-order.device.last_value_timestamp") },
      ],
      //测量值
      measurements: [],
      measurementsColumn: [
        { dataIndex: "name", title: this.$t("page.work-order.device.name") },
        { dataIndex: "alias", title: "别名" },
        { dataIndex: "newData", title: this.$t("page.work-order.device.latest_value") },
        { dataIndex: "unit", title: this.$t("page.work-order.device.unit") },
        { dataIndex: "update", title: this.$t("page.work-order.device.last_value_timestamp") },
      ],
      //维护保养
      repairs: [],
      repairsColumn: [
        { dataIndex: "item", title: this.$t("page.tending.item"), width: "30%" },
        { dataIndex: "names", title: this.$t("page.tending.names"), width: "30%" },
        { dataIndex: "description", title: this.$t("page.tending.description") },
      ],
      //标签
      tags: [],
      tagsColumn: [
        { dataIndex: "key", title: this.$t("page.work-order.device.name") },
        { dataIndex: "value", title: this.$t("page.work-order.value") },
      ],
      //资料库
      files: { image: [], video: [], document: [] },
      //物实例
      instances: [],
      instancesColumn: [{ dataIndex: "name", title: this.$t("page.work-order.name") }],
      alertInfo: {
        content: "",
        variant: "danger",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      obj_model_id: null,
      obj_layer_id: null,
      obj_instence_id: null,
      assetSearchValue: "",
      searchType: true,
      page: 1,
      perPage: 20,
      pages: [],
      dataTypes: [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
        { label: 20, value: 20 },
      ],
      status: "unknown", //物实例状态
      timer: null,
      tabActive: "attributes",
      copySingleData: null,
      topNodeInfo: null,
      currentSelectInfo: null,
      successNode: [],
      qrCodeValue: null,
      qrcodeLogo: require("@/assets/images/u11.jpeg"),
      inum: 0,
    };
  },
  components: {
    Layout,
    PageHeader,
    TreeMenu,
    Table,
    Empty,
    MessageAlert,
    SwiperTool,
    ElPopover,
    vueQr,
  },
  computed: {
    displayedPosts() {
      return this.paginate(this.assetList);
    },
    layerNums() {
      return this.obj_layer_id || localStorage.getItem("layer_num");
    },
    instanceExportUrl() {
      return urlFormat(API_SVC_HOST, SF_API_PREFIX, "/api/instances/export");
    },
  },
  methods: {
    handlerAdd(num) {
      this.copyNumber = Number(this.copyNumber) + num;
      if (this.copyNumber > 10) {
        this.copyNumber = 10;
      }
      if (this.copyNumber < 0) {
        this.copyNumber = 0;
      }
    },
    filterNumber() {
      if (!/^[0-9]+$/.test(this.copyNumber)) {
        this.copyNumber = String(this.copyNumber).replace(/\D/g, "");
      }
      if (this.copyNumber > 10) this.copyNumber = 10;
      if (this.copyNumber < 0) this.copyNumber = 0;
    },
    /* 提交批量复制 */
    copyMoreSubmit(type) {
      if (type == "submit" && this.copyNumber) {
        for (let i = 0; i < this.copyNumber; i++) {
          this.copySingle(this.$t("page.work-order.copy") + (i + 1));
        }
      }
      this.$refs.copyMode.hide();
    },
    /* 复制物实例 */
    copySingle(copyText = this.$t("page.work-order.copy")) {
      let copyId =
        _.get(this.$route, ["query", "asset_id"]) || this.obj_model_id;
      if (copyId) {
        /*
          1. 获取当前节点的所有数据
          2. 创建顶级节点
          3. 遍历子节点，循环创建
        */
        this.getTopNodeInfo(copyId, copyText);
      }
    },
    async getTopNodeInfo(copyId, copyText) {
      Swal.fire({ title: this.$t("page.work-order.in_copy"), showConfirmButton: false });
      Swal.showLoading();
      await getInstanceDetailTree(copyId, { is_tree_table: true }).then(
        (res) => {
          // 1. 获取当前节点的所有数据
          if (res && res.payload) {
            this.topNodeInfo = res.payload;
            this.copySingleData = _.assign(
              _.cloneDeep(this.topNodeInfo),
              this.currentSelectInfo
            );
            this.copySingleData.name += copyText;
            this.copySingleData.id = "";

            // 2. 创建顶级节点
            let params = _.assign(this.copySingleData, {
              children: [],
              model_id: this.copySingleData.deviceProfileId,
              parent_id: this.copySingleData.parent_id,
              product_type: this.copySingleData.product_type,
              status: "new",
            });
            createInstance(params)
              .then((res) => {
                if (res && res.payload) {
                  this.successNode.push(res.payload.id);
                  this.copySingleData = res.payload;
                  // 3.遍历创建子节点
                  if (
                    this.topNodeInfo.children &&
                    this.topNodeInfo.children.length
                  ) {
                    // 多层节点
                    let children = _.cloneDeep(this.topNodeInfo.children);
                    children.forEach((child, index) => {
                      if (child.children && child.children.length) {
                        // 多维层级
                        this.filterChildren(
                          child,
                          this.copySingleData.id,
                          copyText
                        );
                      } else {
                        // 嵌套一层节点
                        child.name += copyText;
                        child.id = "";
                        let params = _.assign(child, {
                          model_id: this.topNodeInfo.deviceProfileId,
                          children: [],
                          parent_id: this.copySingleData.id,
                          product_type: this.copySingleData.product_type,
                        });
                        this.createChildrenNode(params);
                        if (index == children.length - 1) {
                          this.$nextTick(() => {
                            this.getDetail();
                            Swal.close();
                          });
                        }
                      }
                    });
                  } else {
                    // 只有1个节点
                    this.$nextTick(() => {
                      this.getDetail();
                      Swal.close();
                    });
                  }
                }
              })
              .catch((err) => {
                this.handleAlert("danger", err || this.$t("page.work-order.copy_error"));
                Swal.close();
              });
          }
        }
      );
    },
    /* 多维层级 */
    async filterChildren(f_children, parentId, copyText) {
        if(f_children.attributes){
            _.get(f_children,['attributes','attributes']).map(item=>{
                if(item.name== this.$t("page.pump_head_serial_number") ){
                    item.value==''
                }
            })
        }
      // 如果children存在，保存原有children内容
      let oldChildren = [];
      if (f_children.children && f_children.children.length) {
        oldChildren = _.cloneDeep(f_children.children);
      }
      // 创建当前实例
      f_children.name += copyText;
      f_children.id = "";
      let params = _.assign(f_children, {
        model_id: this.topNodeInfo.deviceProfileId,
        children: [],
        parent_id: parentId,
        product_type: this.topNodeInfo.product_type,
      });
      await createInstance(params)
        .then((res) => {
          if (res && res.payload) {
            this.successNode.push(res.payload.id);
            f_children = res.payload;
            f_children.model_id = this.topNodeInfo.deviceProfileId;
            // 递归创建子集
            if (oldChildren && oldChildren.length) {
              oldChildren.forEach((edit_child, index) => {
                this.filterChildren(edit_child, f_children.id, copyText);
                if (index == oldChildren.length - 1) {
                  this.$nextTick(() => {
                    this.getDetail();
                    Swal.close();
                  });
                }
              });
            }
          }
        })
        .catch((err) => {
          this.handleAlert("danger", err || this.$t("page.work-order.copy_error"));
          Swal.close();
        });
    },
    /* 单层级 */
    async createChildrenNode(params) {
      await createInstance(params)
        .then((res) => {
          if (res && res.payload) {
            this.successNode.push(res.payload.id);
            this.copySingleData.children.push(res.payload);
            this.copySingleData = _.assign(this.copySingleData, {
              model_id: this.topNodeInfo.deviceProfileId,
            });
            this.getDetail();
          }
        })
        .catch((err) => {
          this.handleAlert("danger", err || this.$t("page.work-order.copy_error"));
          Swal.close();
        });
    },
    // 递归查找匹配id
    filterTreeNode(id, list) {
      let newarr = [];
      // 1.检测数组是否存在是否为空
      if (list && list.length) {
        // 直接遍历
        list.filter((v) => {
          if (v.children && v.children.length) {
            let ab = this.filterTreeNode(id, v.children);
            // 递归查询
            if (ab && ab.length) {
              newarr = v;
            }
          } else {
            if (id == list.id) {
              newarr = list;
            }
          }
        });
      }
      return newarr;
    },
    //分页
    setPages() {
      let numberOfPages = Math.ceil(this.assetList.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    moment,
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    getDepths(obj, k) {
      this.inum = Math.max(this.inum, k);
      if (obj.children.length > 0) {
        obj.children.forEach((v) => {
          this.getDepths(v, k + 1);
        });
      }
    },
    getDetail(num) {
      let params = {
        is_tree_table: true,
      };
      getInstancesDetail(params)
        .then((res) => {
          if (res.payload.data && res.payload.data.length > 0) {
            var inumList = [];
            this.assetList = this.recursionArr(res.payload.data);
            this.assetList.map((item) => {
              this.getDepths(item, 1);
              inumList.push({ [item.name]: this.inum });
              this.inum = 0;
            });
            //实例层级
            localStorage.setItem("inumList", JSON.stringify(inumList));
            this.originAssetList = this.assetList;
            this.setPages();
            let assetId = _.get(this.$route, ["query", "asset_id"]);
            if (assetId) {
              localStorage.setItem(
                "parId",
                this.find(this.assetList, assetId)[0]
              );
            }
            if (num) {
              this.getDetailId(this.assetList[0]);
              this.obj_model_id = this.assetList[0].id;
              this.obj_layer_id = this.assetList[0].num;
              // this.selected = "a" + res.payload.data[0].id;
            }
            this.currentSelectInfo = this.filterDetail(
              _.cloneDeep(this.originAssetList),
              assetId
            );
          }
        })
        .catch(() => {
          this.handleAlert("danger", this.$t("page.work-order.failed_to_device_list"));
        });
    },
    filterDetail(list, id) {
      if (!list && !list.length) return null;
      for (let i in list) {
        let item = list[i];
        if (item.id === id) return item;
        else {
          if (item.children && item.children.length) {
            let obj = this.filterDetail(item.children, id);
            if (obj) return obj;
          }
        }
      }
    },
    //递归数组
    recursionArr(data) {
      let result = [];
      let num = 0;
      let queue = data;
      while (queue.length > 0) {
        num += 1;
        [...queue].forEach((child, i) => {
          queue.shift();
          child.index = i;
          child.num = num;
          child.iconType = true;
          child["subId"] = "a" + child.id;
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }
      return result.filter((item) => {
        return item.num == 1;
      });
    },
    funRecursion(list, id) {
      for (let i in list) {
        if (list[i].id == id) {
          // return [list[i]];
          return [list[i].id];
        }
        if (list[i].children) {
          let node = this.funRecursion(list[i].children, id);
          if (node !== undefined) {
            // return node.concat(list[i]);
            return node.concat(list[i].id);
          }
        }
      }
    },
    //数组层深分级
    getDepth(json) {
      var arr = [];
      arr.push(json);
      var depth = 0;
      while (arr.length > 0) {
        var temp = [];
        for (var l = 0; l < arr.length; l++) {
          temp.push(arr[l]);
        }
        arr = [];
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].children) {
            for (var j = 0; j < temp[i].children.length; j++) {
              arr.push(temp[i].children[j]);
            }
          }
        }
        if (arr.length >= 0) {
          depth++;
        }
      }
      return depth;
    },
    //树结构搜索过滤
    filterTree(nodes, query) {
      // 过滤关键字
      let predicate = (node) => {
        node["depth"] = this.getDepth(node);

        var str = "";
        var strs = "";
        node.tags.map((item) => {
          str += item.key;
          strs += item.value;
        });
        if (
          node.name.indexOf(query) > -1 ||
          str.indexOf(query) > -1 ||
          strs.indexOf(query) > -1
        ) {
          return true;
        } else {
          return false;
        }
      };
      if (!(nodes && nodes.length)) {
        return [];
      }
      let newChildren = [];
      for (let node of nodes) {
        if (predicate(node)) {
          newChildren.push(node);
          node.children = this.filterTree(node.children, query);
        } else {
          newChildren.push(...this.filterTree(node.children, query));
        }
      }
      return newChildren.length ? newChildren : [];
    },
    initData() {
      this.detailInfo = {};
      this.tags = [];
      this.attributes = [];
      this.measurements = [];
      this.instances = [];
      this.repairs = [];
      this.files = { image: [], video: [], document: [] };
    },
    initWebSocket() {
      const interval = setInterval(() => {
        const stompClient = this.$websocket.getters.stompClient();
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval);
          stompClient.subscribe("/topic/stream", (msg) => {
            if (msg && msg.body) {
              let websocketdata = JSON.parse(msg.body);
              if (
                this.detailInfo.id &&
                this.detailInfo.id == websocketdata.shadowId
              ) {
                this.status = "health";
                this.measurements.map((item) => {
                  websocketdata.report.map((s) => {
                    if (item["key"] == s.id) {
                      item["newData"] = numberFormat(s.v);
                      item["update"] = moment().format("YYYY-MM-DD HH:mm:ss");
                    }
                  });
                });
              }
            }
          });
        } else {
          if (!localStorage.getItem("accessToken")) return;
          const _url =
            SOCKET_SVC_HOST +
            "/messaging/stomp?access_token=" +
            localStorage.getItem("accessToken");
          this.$websocket.dispatch("WEBSOCKET_INIT", _url);
        }
      }, 1000);
    },
    getTimeseries(obj) {
      getLatestTimeseries(obj.id)
        .then((res) => {
          if (res.payload && res.payload.length) {
            let data = res.payload;
            let diff = moment().diff(moment(data[0].ts), "minute"); //判断测点3分钟内是否更新
            if (diff < 3) {
              this.status = "health";
            } else {
              this.status = "unknown";
            }
            this.measurements.map((item) => {
              data.map((s) => {
                for (let i in s) {
                  if (item["key"] == i) {
                    item["newData"] = '无';
                    item["update"] = '无';
                  }
                }
              });
            });
          }
        })
        .catch(() => {
          this.status = "unknown";
        });
    },
    getStatus(obj) {
      this.obj_layer_id = obj.num;
      this.getTimeseries(obj);
    },
    getDetailId(obj, type) {
      this.currentSelectInfo = obj;
      this.selected = "a" + obj.id;
      //父级id列表

      this.status = "unknown";
      if (obj) {
        this.initData();
        let params = {
          id: obj.id,
        };
        this.obj_instence_id = obj.id;
        this.obj_layer_id = obj.num;
        getInstancesDetailId(params)
          .then((res) => {
            if (res.payload) this.detailInfo = res.payload;
            if (res.payload.tags) this.tags = res.payload.tags;
            if (res.payload.files) this.files = res.payload.files;
            if (res.payload.repairs) {
              this.repairs = res.payload.repairs;
              // this.repairs &&
              //   this.repairs.forEach((item) => {
              //     item.names = item.names.join(",");
              //   });
            }
            if (res.payload.children) {
              this.instances = res.payload.children;
            }
            if (res.payload.attributes) {
              this.attributes = res.payload.attributes.attributes;
              this.setQRcodeUrl(res.payload.extra_info);
              this.measurements = res.payload.attributes.measurements;
            }
            this.detailInfo.stock = this.find(
              this.assetList,
              this.detailInfo.id
            );
            //父级id列表

            localStorage.setItem(
              "parId",
              this.detailInfo.stock && this.detailInfo.stock[0]
            );

            this.detailInfo["isIndex"] = 0;
            this.detailInfo.stock &&
              this.detailInfo.stock.map((item, index) => {
                if (this.detailInfo.id == item) {
                  this.detailInfo["isIndex"] = index;
                }
              });
            if (this.assetList.length > 0) {
              this.assetList.map((item) => {
                if (item.id == this.detailInfo.id) {
                  this.detailInfo["isParent"] = false;
                }
              });
            }

            this.getStatus(obj);

            var box1 = document.getElementById(type || "assetAttributesId");
            box1.click();
            //   { tag: "1", subId: "id1", name: "1#轧机", num: 1 },
          })
          .catch(() => {
            this.handleAlert("danger", this.$t("page.work-order.failed_to_product_detail"));
          });
      }
    },
    //生成二维码
    setQRcodeUrl(extra_info) {
      let qrcodeCheckedList = extra_info.qrcodeCheckedList;
      let codes = "";
      this.attributes.map((attr) => {
        if (
          attr.group == this.$t("page.work-order.device.equipment_delivery_information") &&
          (!qrcodeCheckedList || qrcodeCheckedList.includes(attr.id))
        ) {
          let unit = attr.unit == this.$t("page.no") ? "" : attr.unit;
          codes += `${attr.name}:${attr.value} ${unit};`;
        }
      });

      this.qrCodeValue = _.cloneDeep(codes);
    },
    //获取父节点
    find(arr, id) {
      let stock = [];
      let going = true;
      var warker = function (arr, id) {
        arr.forEach((item) => {
          if (!going) return;
          stock.push(item.id);
          if (item.id == id) {
            going = false;
          } else if (item.children) {
            warker(item.children, id);
          } else {
            stock.pop();
          }
        });
        if (going) stock.pop();
      };
      warker(arr, id);
      return stock;
    },
    deleteInstancesDetail() {
      let params = {
        id: this.detailInfo.id,
      };
      deleteInstancesDetailId(params)
        .then(() => {
          this.handleAlert("success", this.$t("base.delete_success"), "ri-check-double-line");
          this.getDetail(1);
          //   { tag: "1", subId: "id1", name: "1#轧机", num: 1 },
        })
        .catch((err) => {
          if (err.message.message) {
            this.handleAlert("danger", err.message.message);
          }
        });
    },
    exportInstances() {
      // let url = null;
      // if (process.env.VUE_APP_API_SVC_HOST) {
      //   if (process.env.VUE_APP_API_SVC_HOST.includes("oodt-gateway")) {
      //     url =
      //       "https:" +
      //       process.env.VUE_APP_API_SVC_HOST +
      //       "/sf/api/instances/export";
      //   } else {
      //     url = process.env.VUE_APP_API_SVC_HOST + "/sf/api/instances/export";
      //   }
      // } else {
      //   url = "/sf/api/instances/export";
      // }

      axios
        .get(this.instanceExportUrl, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          if (!res) return;
          //获取文件名
          // const fileName = decodeURIComponent(res.headers["content-disposition"].split("utf-8''")[1])
          // blob
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let link = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //下载链接
          link.href = href;
          link.download = `measurements-${moment()
            .tz(this.$tz)
            .format("YYYYMMDD")}.xlsx`; //下载后文件名
          document.body.appendChild(link);
          link.click(); //点击下载
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放blob对象
        })
        .catch(() => {
          this.handleAlert("danger", this.$t("base.file_export_failed"));
        });
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
    sortByInt(array, key) {
      return array.sort(function (b, a) {
        var x = a[key];
        var y = b[key];
        return y - x;
      });
    },
    //物实例搜索
    assetSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();

        if (
          this.filterTree(this.originAssetList, this.assetSearchValue).length ==
          0
        ) {
          this.searchType = false;
        } else {
          this.searchType = true;
          this.assetList = this.recursionArr(
            this.filterTree(this.originAssetList, this.assetSearchValue)
          );
          this.assetList = this.sortByInt(this.assetList, "depth").reverse();
          this.setPages();

          this.getDetailId(this.assetList[0]);
          this.obj_model_id = this.assetList[0].id;
        }

        if (this.assetSearchValue.length == 0) {
          this.searchType = true;

          let assetId = _.get(this.$route, ["query", "asset_id"]);
          if (assetId) {
            let params = {
              subId: "a" + assetId,
              id: assetId,
            };
            this.getDetail();
            this.getDetailId(params);
          } else {
            this.getDetail(1);
          }
        }
      }
    },
    //删除子节点父节点跳转
    noDeleteModelDetail(type) {
      switch (type) {
        case "p":
          this.$router.push({
            path: "/asset/form",
            query: {
              type: "edit",
              title: this.$t("page.work-order.device.edit"),
              instance_id: this.detailInfo.stock[this.detailInfo.isIndex - 1],
              layer_num: this.obj_layer_id,
            },
          });
          break;
        case "s":
          this.$router.push({
            path: "/asset/form",
            query: {
              type: "edit",
              title: this.$t("page.work-order.device.edit"),
              instance_id: this.detailInfo.id,
              layer_num: this.obj_layer_id,
            },
          });
          break;
        default:
          break;
      }
    },
    deleteFile(i, type) {
      let files = _.cloneDeep(this.files);
      files[type].splice(i, 1);
      let repairs = _.cloneDeep(this.repairs);
      repairs.forEach((item) => {
        item.names = item.names.split(",");
      });
      let params = {
        name: this.detailInfo.name,
        model_id: this.detailInfo.deviceProfileId,
        attributes: JSON.stringify({
          attributes: this.attributes,
          measurements: this.measurements,
        }),
        repairs: JSON.stringify(repairs),
        tags: JSON.stringify(this.tags),
        files: JSON.stringify(files),
        children: JSON.stringify(this.instances),
        product_type: this.detailInfo.product_type,
      };
      editInstance(this.detailInfo.id, params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) == 200) {
            let params = {
              subId: "a" + this.detailInfo.id,
              id: this.detailInfo.id,
            };
            this.getDetailId(params, "databaseId");
            this.getStatus(params);

            Swal.fire(this.$t('base.delete_success'));
          }
        })
        .catch(() => {
          Swal.fire(this.$t('base.delete_failed'));
        });
    },
    editFile() {
      this.$router.push({
        path: "/asset/form",
        query: {
          type: "edit",
          title: this.$t("page.work-order.device.edit"),
          model_id: this.obj_model_id,
          instance_id: this.obj_instence_id,
          layer_num: this.obj_layer_id,
        },
      });
    },
    //解决a标签锚点定位改变url问题
    goTab(idName) {
      this.tabActive = idName;
    },
    delAsset() {
      console.log(this.detailInfo);
    },
  },
  mounted() {
    let assetId = _.get(this.$route, ["query", "asset_id"]);
    let istoId = _.get(this.$route, ["query", "isto"]);
    if (istoId) {
      if (istoId == "equipment") {
        var btn = document.getElementById("delete_asset");
        btn.click();
      } else {
        var btns = document.getElementById("edit_asset");
        btns.click();
      }
    }
    if (assetId) {
      this.page = localStorage.getItem("page") || this.page;
      this.perPage = localStorage.getItem("perPage") || this.perPage;
      let params = {
        subId: "a" + assetId,
        id: assetId,
      };
      this.getDetail();
      this.getDetailId(params);
      this.getStatus(params);
    } else {
      this.getDetail(1);
    }
    this.initWebSocket();
  },
  beforeUnmount() {
    this.clearTimer();
  },

  watch: {
    successNode: {
      handler(val) {
        console.log("successNode", val);
      },
      deep: true,
    },
    assetList() {
      this.pages = [];
      this.setPages();
    },
    perPage() {
      this.page = localStorage.getItem("page") || this.page;
      this.pages = [];
      localStorage.setItem("perPage", this.perPage);
      localStorage.setItem("page", this.page);

      this.setPages();
    },
    /* "$route.query"() {
      let assetId = _.get(this.$route, ["query", "asset_id"]);
      if (assetId) {
        let params = {
          subId: "a" + assetId,
          id: assetId,
        };
        this.getDetail();
        this.getDetailId(params);
      }
    }, */
    page() {
      localStorage.setItem("page", this.page);
      localStorage.setItem("perPage", this.perPage);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-show="!assetList.length">
      <div class="row gy-sm-4 gy-md-5 gy-lg-6 gy-xxl-7">
        <div class="col-12">
          <div class="text-end">
            <button class="btn btn-primary me-2" type="button">{{this.$t('base.refresh')}}</button>
            <router-link
              :to="{
                path: '/asset/form',
                query: {
                  type: 'create',
                  title: this.$t('page.work-order.device.create'),
                  current_type: this.currentType,
                },
              }"
              class="btn btn-primary text-light"
              ><i class="ri-add-line align-bottom me-1"></i
              >{{ this.$t('page.work-order.device.mkdev') }}</router-link
            >
          </div>
        </div>
        <div class="col-12 text-center">
          <Empty :emptyInfo="emptyInfo"></Empty>
        </div>
      </div>
    </div>
    <div style="display: flex; width: 100%" v-show="assetList.length">
      <!-- 树结构 -->
      <div style="width: 300px; flex: none; margin-right: 1.5rem">
        <div class="card" style="width: 100%">
          <div
            class="card-body d-flex justify-content-between"
            style="padding-bottom: 0"
          >
            <p class="card-title" style="">{{this.$t("page.work-order.device.text")}}</p>
            <p style="margin-bottom: 0">
              <button
                v-if="false"
                class="btn btn-primary me-1"
                @click="exportInstances"
              >
                <i class="ri-download-2-line align-bottom me-1"></i>{{this.$t('base.export')}}
              </button>
              <router-link
                :to="{
                  path: '/asset/form',
                  query: {
                    type: 'create',
                    title: this.$t('page.work-order.device.create'),
                  },
                }"
                class="btn btn-primary text-light"
                ><i class="ri-add-line align-bottom me-1"></i
                >{{this.$t('page.work-order.device.mkdev')}}</router-link
              >
            </p>
          </div>

          <div class="app-search d-md-block" style="margin: 0 20px">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('base.search_device_name')"
                autocomplete="off"
                id="search-options"
                @keydown="assetSearch"
                v-model="assetSearchValue"
              />
              <span class="mdi mdi-magnify search-widget-icon"></span>
              <span
                class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                id="search-close-options"
              ></span>
            </div>
          </div>

          <div>
            <div class="d-flex justify-content-between m-2 mt-0">
              <select
                style="width: 70px"
                class="form-select form-select-sm"
                v-model="perPage"
              >
                <option v-for="a in dataTypes" :key="a.value" :value="a.value">
                  {{ a.label }}
                </option>
              </select>
              <div class="pagination-wrap hstack gap-2">
                <a
                  class="page-item pagination-prev"
                  href="javascript:void(0);"
                  @click="page != 1 && page--"
                >
                  <i class="bx bx-chevron-left"></i>
                </a>

                <ul class="pagination listjs-pagination mb-0">
                  <li
                    v-for="(pageNumber, index) in pages"
                    v-show="index < 2 || index == page - 1"
                    :class="{
                      active: pageNumber == page,
                      disabled: pageNumber == '...',
                    }"
                    :key="index"
                    @click="page = pageNumber"
                  >
                    <a class="page" href="javascript:void(0);">{{
                      pageNumber
                    }}</a>
                  </li>
                  <a
                    v-if="pages.length > 2 && page != pages[pages.length - 1]"
                    class="page"
                    href="javascript:void(0);"
                    >...</a
                  >
                </ul>
                <a
                  class="page-item pagination-next"
                  href="javascript:void(0);"
                  @click="page < pages.length && page++"
                >
                  <i class="bx bx-chevron-right"></i>
                </a>
              </div>
            </div>
            <div style="background: #e2e8ed" class="lh-lg p-1 ps-4 mb-2">
              {{this.$t('page.work-order.device-name')}}
            </div>
            <b-form-group
              v-if="searchType"
              style="overflow: auto; max-height: 90vh"
            >
              <TreeMenu
                :selected="selected"
                :successNode="successNode"
                :modelList="displayedPosts"
                @getDetailId="getDetailId"
                @getDetail="getDetail"
              />
            </b-form-group>
            <div v-if="!searchType" class="text-center text-black-50 m-2">
              {{this.$t('base.unmatched_data')}}
            </div>
          </div>
        </div>
      </div>
      <!-- 详情 -->
      <div style="width: calc(100% - 300px - 1.5rem)">
        <div class="m-3 d-flex justify-content-between">
          <h3>{{ detailInfo.name }}</h3>
          <div>
            <button
              id="copySingle"
              type="button"
              class="btn btn-primary waves-effect waves-light m-2 pe-4 ps-4"
              @click="copySingle()"
            >
              <i class="ri-file-copy-2-line align-bottom me-1"></i>
              {{this.$t("page.work-order.copy")}}
            </button>

            <el-popover
              placement="top"
              :width="230"
              trigger="click"
              ref="copyMode"
            >
              <template #reference>
                <el-button
                  style="
                    height: 37.5px;
                    background: #405189;
                    border: 1px solid #405189;
                    color: #fff;
                    font-size: 0.8125rem;
                    font-weight: 400;
                  "
                  id="copyMore"
                  type="button"
                  ><i class="ri-file-copy-2-fill align-bottom me-1"></i>
                  {{ this.$t("page.work-order.bulk_copy") }}</el-button
                >
              </template>
              <div>
                <div class="d-flex align-items-center">
                  <span>{{ this.$t("page.work-order.all_copy") }}</span>
                  <div class="input-step mx-1">
                    <button type="button" class="minus" @click="handlerAdd(-1)">
                      –
                    </button>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="copyNumber"
                      @input="filterNumber()"
                    />
                    <button type="button" class="plus" @click="handlerAdd(+1)">
                      +
                    </button>
                  </div>
                  <span>{{this.$t('base.time')}}</span>
                </div>
                <div class="d-flex mt-3 justify-content-end">
                  <b-button
                    variant="light"
                    size="sm"
                    class="me-3"
                    @click="copyMoreSubmit('close')"
                  >
                   {{this.$t('base.cancel')}}
                  </b-button>
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="copyMoreSubmit('submit')"
                    >{{this.$t('base.confirm')}}</b-button
                  >
                </div>
              </div>
            </el-popover>

            <router-link
              id="edit_asset"
              :to="{
                path: '/asset/form',
                query: {
                  type: 'edit',
                  title: this.$t('page.work-order.device.edit'),
                  model_id: obj_model_id,
                  instance_id: obj_instence_id,
                  layer_num: obj_layer_id || layerNums,
                },
              }"
              class="btn btn-primary waves-effect waves-light m-2 pe-4 ps-4 text-light"
              ><i class="ri-pencil-fill align-bottom me-1"></i>{{this.$t('base.edit')}}</router-link>
            <button
              id="delete_asset"
              type="button"
              class="btn btn-primary waves-effect waves-light m-2 pe-4 ps-4"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              @click="delAsset"
            >
              <i class="ri-delete-bin-5-fill align-bottom me-1"></i>
              {{this.$t('base.delete')}}
            </button>
          </div>
        </div>
        <!-- 基本信息 -->
        <div class="card" style="width: 100%">
          <div class="card-header">
            <h6 class="card-title mb-0">{{this.$t('page.basic-info')}}</h6>
          </div>
          <div class="card-body m-2 d-flex align-items-center">
            <div class="flex-1">
              <div class="row">
                <div class="col-4">
                  <p>{{this.$t('page.work-order.device.id')}}</p>
                  <p>{{ detailInfo.id }}</p>
                </div>
                <div class="col-4">
                  <p>{{this.$t('base.type')}}</p>
                  <p>
                    {{
                      detailInfo.product_type == "1" ? this.$t('page.work-order.device.single') : this.$t('page.work-order.device.unit_type')
                    }}
                  </p>
                </div>
                <div class="col-4">
                  <p>{{this.$t('base.product')}}</p>
                  <p>
                    <router-link
                      :to="{
                        path: '/model',
                        query: {
                          model_id: detailInfo.deviceProfileId,
                        },
                      }"
                      >{{
                        detailInfo.extra_info &&
                        detailInfo.extra_info.product_list &&
                        detailInfo.extra_info.product_list.join("/")
                      }}</router-link
                    >
                  </p>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-4">
                  <p>{{ this.$t('base.last_modification_date') }}</p>
                  <p>
                    {{
                      (detailInfo.updated_time &&
                        moment(detailInfo.updated_time)
                          .tz($tz)
                          .format("YYYY-MM-DD HH:mm:ss")) ||
                      ""
                    }}
                  </p>
                </div>
                <div class="col">
                  <p>{{this.$t('base.create_date')}}</p>
                  <p>
                    {{
                      (detailInfo.created_time &&
                        moment(detailInfo.created_time)
                          .tz($tz)
                          .format("YYYY-MM-DD HH:mm:ss")) ||
                      ""
                    }}
                  </p>
                </div>
                <div class="col-4">
                  <p>{{this.$t('base.connection_status')}}</p>
                  <p>
                    <i
                      :class="['ri-checkbox-blank-circle-fill', status, 'me-1']"
                    ></i>
                  </p>
                </div>
              </div>
            </div>

            <div style="width: 130px; height: 130px">
              <vue-qr
                v-if="qrCodeValue"
                ref="qrcode"
                :text="qrCodeValue + ' '"
                :logo-src="qrcodeLogo"
                :size="130"
                :margin="0"
                :logo-margin="2"
              ></vue-qr>
            </div>
          </div>
        </div>
        <!-- tabs -->
        <div class="card" style="width: 100%">
          <div class="card-header m-2">
            <ul
              class="nav nav-tabs-custom rounded card-header-tabs nav-justified border-bottom-0 mx-n3"
              role="tablist"
            >
              <li class="nav-item">
                <a
                  id="assetAttributesId"
                  :class="['nav-link', tabActive == 'attributes' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'attributes' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('attributes')"
                  role="tab"
                >
                  {{this.$t('base.attribute')}}
                </a>
              </li>
              <li class="nav-item">
                <a
                  :class="['nav-link', tabActive == 'measurements' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'measurements' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('measurements')"
                  role="tab"
                >
                  {{this.$t('base.gauge_point')}}
                </a>
              </li>
              <li class="nav-item">
                <a
                  :class="['nav-link', tabActive == 'instances' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'instances' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('instances')"
                  role="tab"
                >
<!--                  {{this.$t('base.associated_apparatus')}}-->
                  {{this.$t('base.associated')}}
                </a>
              </li>
              <li class="nav-item">
                <a
                  :class="['nav-link', tabActive == 'cryptoSell' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'cryptoSell' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('cryptoSell')"
                  role="tab"
                >
                  {{this.$t("page.tending.item")}}
                </a>
              </li>
              <li class="nav-item">
                <a
                  id="databaseId"
                  :class="['nav-link', tabActive == 'databases' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'databases' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('databases')"
                  role="tab"
                >
                  {{this.$t('base.data_bank')}}
                </a>
              </li>
              <li class="nav-item">
                <a
                  :class="['nav-link', tabActive == 'tags' && 'active']"
                  data-bs-toggle="tab"
                  :style="{
                    cursor: 'pointer',
                    color: tabActive == 'tags' ? '#6691E7' : '#495057',
                  }"
                  @click="goTab('tags')"
                  role="tab"
                >
                  {{this.$t('base.tag')}}
                </a>
              </li>
            </ul>
          </div>
          <div class="card-body m-2">
            <div class="tab-content text-muted">
              <div
                :class="['tab-pane', tabActive == 'attributes' && 'active']"
                id="attributes"
                role="tabpanel"
              >
                <!-- Table Head -->
                <Table
                  :tableData="attributes"
                  :column="attributesColumn"
                ></Table>
                <div
                  v-if="attributes.length == 0"
                  class="text-center text-black-50"
                >
                  {{this.$t('base.no_attribute')}}
                </div>
              </div>
              <!--end tab-pane-->

              <div
                :class="['tab-pane', tabActive == 'measurements' && 'active']"
                id="measurements"
                role="tabpanel"
              >
                <Table
                  :tableData="measurements"
                  :column="measurementsColumn"
                ></Table>
                <div
                  v-if="measurements.length == 0"
                  class="text-center text-black-50"
                >
                  {{this.$t('base.no_gauge_point')}}
                </div>
              </div>
              <div
                :class="['tab-pane', tabActive == 'instances' && 'active']"
                id="instances"
                role="tabpanel"
              >
                <Table
                  :tableData="instances"
                  :column="instancesColumn"
                  @getDetailId="getDetailId"
                ></Table>
                <div
                  v-if="instances.length == 0"
                  class="text-center text-black-50"
                >
                  {{this.$t('base.no_associated')}}
                </div>
              </div>
              <div
                :class="['tab-pane', tabActive == 'cryptoSell' && 'active']"
                id="cryptoSell"
                role="tabpanel"
              >
                <Table :tableData="repairs" :column="repairsColumn"></Table>
                <div
                  v-if="repairs.length == 0"
                  class="text-center text-black-50"
                >
                  {{this.$t('base.no_tending')}}
                </div>
              </div>

              <!-- 资料库tab-内容 -->
              <div
                :class="['tab-pane', tabActive == 'databases' && 'active']"
                id="databases"
                role="tabpanel"
              >
                <div class="p-2 w-100 text-body">
                  <!-- 图片 -->
                  <div class="w-100" v-show="files['image'].length">
                    <div>
                      <div class="border-primary fs-14 material-title">
                        {{this.$t('base.picture')}}
                      </div>
                    </div>
                    <div class="product-img-slider sticky-side-div ps-5 pe-5">
                      <SwiperTool
                        :swiperInfo="{
                          type: 'image',
                          page: 'modeltag',
                          slidesPerView: 10,
                          spaceBetween: 10,
                          actionsClass: [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-pencil-fill', action: 'edit' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                          ],
                        }"
                        :list="files['image']"
                        @deleteFile="deleteFile"
                        @editFile="editFile"
                      >
                      </SwiperTool>
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div class="mt-4 mb-4 w-100" v-show="files['video'].length">
                    <div>
                      <div class="border-primary fs-14 material-title">
                        {{this.$t('base.video')}}
                      </div>
                    </div>
                    <div class="product-img-slider sticky-side-div ps-5 pe-5">
                      <SwiperTool
                        :swiperInfo="{
                          type: 'video',
                          page: 'modeltag',
                          spaceBetween: 10,
                          slidesPerView: 10,
                          actionsClass: [
                            { name: 'ri-play-circle-line', action: 'play' },
                            { name: 'ri-pencil-fill', action: 'edit' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                          ],
                        }"
                        :list="files['video']"
                        @deleteFile="deleteFile"
                        @editFile="editFile"
                      >
                      </SwiperTool>
                    </div>
                  </div>
                  <!-- 文档 -->
                  <div class="w-100" v-show="files['document'].length">
                    <div>
                      <div class="border-primary fs-14 material-title">
                        {{this.$t('base.document')}}
                      </div>
                    </div>
                    <div class="product-img-slider sticky-side-div ps-5 pe-5">
                      <SwiperTool
                        :swiperInfo="{
                          type: 'document',
                          page: 'modeltag',
                          spaceBetween: 10,
                          slidesPerView: 10,
                          actionsClass: [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-pencil-fill', action: 'edit' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                          ],
                        }"
                        :list="files['document']"
                        @deleteFile="deleteFile"
                        @editFile="editFile"
                      >
                      </SwiperTool>
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="['tab-pane', tabActive == 'tags' && 'active']"
                id="tags"
                role="tabpanel"
              >
                <Table :tableData="tags" :column="tagsColumn"></Table>
                <div v-if="tags.length == 0" class="text-center">{{this.$t('base.no_tag')}}</div>
              </div>
              <!--end tab-pane-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- staticBackdrop Modal -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header mb-3 fs-16">
            <div>{{this.$t('page.work-order.device.delete')}}{{ detailInfo.name }}</div>
            <div>
              <i
                style="cursor: pointer"
                class="ri-close-line"
                data-bs-dismiss="modal"
              ></i>
            </div>
          </div>
          <div class="modal-body text-center p-2 mb-2">
            <lord-icon
              src="https://cdn.lordicon.com/lupuorrc.json"
              trigger="loop"
              colors="primary:#121331,secondary:#08a88a"
              style="width: 120px; height: 120px"
            >
            </lord-icon>

            <div>
              <p class="fs-14 mb-2">
                <i style="color: #f06548" class="ri-error-warning-line"></i>
                <span
                  v-if="
                    detailInfo.children &&
                    detailInfo.children.length == 0 &&
                    detailInfo.isIndex == 0
                  "
                  >{{this.$t('page.delete_all_data')}}</span
                >
                <span
                  v-if="
                    detailInfo.children &&
                    detailInfo.children.length > 0 &&
                    detailInfo.isIndex != 0
                  "
                  >{{this.$t('page.parent_child_node')}}</span
                >
                <span
                  v-if="
                    detailInfo.children &&
                    detailInfo.children.length == 0 &&
                    detailInfo.isIndex != 0
                  "
                  >{{this.$t('page.parent_node')}}</span
                >
                <span
                  v-if="
                    detailInfo.children &&
                    detailInfo.children.length > 0 &&
                    detailInfo.isIndex == 0
                  "
                  >{{this.$t('page.child_node')}}</span
                >
              </p>
            </div>
            <div class="modal-footer text-center p-2 justify-content-center">
              <div class="hstack gap-2 justify-content-center">
                <a
                  href="javascript:void(0);"
                  class="btn fw-medium btn-light"
                  data-bs-dismiss="modal"
                  >{{this.$t('base.cancel')}}</a
                >

                <a
                  v-if="
                    detailInfo.children &&
                    detailInfo.children.length == 0 &&
                    detailInfo.isIndex == 0
                  "
                  href="javascript:void(0);"
                  @click="deleteInstancesDetail"
                  data-bs-dismiss="modal"
                  class="btn btn-primary"
                  >{{this.$t('base.done')}}</a
                >
                <a
                  v-if="detailInfo.children && detailInfo.isIndex != 0"
                  href="javascript:void(0);"
                  @click="noDeleteModelDetail('p')"
                  data-bs-dismiss="modal"
                  class="btn btn-primary"
                  >{{this.$t('page.edit_parent')}}</a
                >
                <a
                  v-if="detailInfo.children && detailInfo.children.length > 0"
                  href="javascript:void(0);"
                  @click="noDeleteModelDetail('s')"
                  data-bs-dismiss="modal"
                  class="btn btn-primary"
                  >{{this.$t('page.edit_child')}}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </Layout>
</template>
<style lang="scss" scoped>
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}
</style>
